import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
// Generic tab component - single responsibility: tab switching only
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = {
    index: { type: Number, default: 0 },
    param: String
  }

  connect() {
    this.showTab(this.indexValue)
  }

  select(event) {
    const selectedIndex = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(selectedIndex)
    this.rememberInUrl(event.currentTarget.dataset.tabsKey)
  }

  // Keeps ?<param>=<key> in step so a reload or coming back opens the same tab
  rememberInUrl(key) {
    if (!this.paramValue || !key) return

    const url = new URL(window.location.href)
    url.searchParams.set(this.paramValue, key)
    window.history.replaceState(window.history.state, "", url)
  }

  showTab(index) {
    this.indexValue = index

    this.tabTargets.forEach((tab, i) => {
      const isActive = i === index

      if (isActive) {
        tab.classList.add("border-b-2", "border-crust-500", "text-crust-500", "font-semibold")
        tab.classList.remove("text-charcoal-600", "hover:text-charcoal-800")
        tab.setAttribute("aria-selected", "true")

        // If this tab has notification-auto-read controller, trigger mark as read
        const autoReadController = this.application.getControllerForElementAndIdentifier(
          tab,
          "notification-auto-read"
        )
        if (autoReadController && typeof autoReadController.markAsRead === "function") {
          autoReadController.markAsRead()
        }
      } else {
        tab.classList.remove("border-b-2", "border-crust-500", "text-crust-500", "font-semibold")
        tab.classList.add("text-charcoal-600", "hover:text-charcoal-800")
        tab.setAttribute("aria-selected", "false")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })
  }
}
